export default {
  licenseKey: 'gpl-v3'
};